import { connect } from 'react-redux';
import { actions as modalActions } from '~/modals/reducer';
import DeleteCampaignModal from './components/DeleteCampaignModal';
import { actions } from './reducer';

export default connect(
  (state) => ({
    translations: state.i18n.translations.campaigns.deleteCampaignModal,
    loading: state.deleteCampaignModal.loading,
    campaign: state.deleteCampaignModal.campaign,
  }),
  (dispatch) => ({
    hideModal: () => dispatch(modalActions.hideDeleteCampaignModal()),
    deleteCampaign: () => dispatch(actions.deleteCampaign()),
  })
)(DeleteCampaignModal);
export { default as reducer, actions, actionTypes } from './reducer';
export { default as middleware } from './middleware';
